import { render, staticRenderFns } from "./greetings.vue?vue&type=template&id=0ea9b865"
import script from "./greetings.vue?vue&type=script&lang=js"
export * from "./greetings.vue?vue&type=script&lang=js"
import style0 from "./greetings.vue?vue&type=style&index=0&id=0ea9b865&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports